import React from "react";
import { Box, IconButton, Stack } from "@mui/material";
import { Close } from "@mui/icons-material";
import AttachmentMergeDroppable from "./AttachmentMergeDroppable.tsx";
import { MediaObject } from "../../types/MediaObject.ts";

type AttachmentMergeCombinableProps = {
  combinable: Array<number>;
  mediaObjects: Array<MediaObject>;
  removeCombinable: Function;
  index: number;
};
export default function AttachmentMergeCombinable({
  combinable,
  index,
  removeCombinable,
  mediaObjects,
}: AttachmentMergeCombinableProps) {
  return (
    <Box>
      <Stack
        direction={"row"}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>Erstelltes Dokument {index + 1}</strong>
        <IconButton disabled={combinable.length > 0} onClick={() => removeCombinable(index)}>
          <Close />
        </IconButton>
      </Stack>
      <AttachmentMergeDroppable combinable={combinable} index={index} mediaObjects={mediaObjects} />
    </Box>
  );
}
